import React, { useState, useContext } from 'react';
import { Toast } from './../UI/toast/Toast'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import PageHeader from '../common/PageHeader'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import withRedirect from '../../helpers/hoc/withRedirect'
import { useParams } from 'react-router'
import { createDebtToPay } from '../../helpers/api/finance';
import { CurrencyContext } from "../../context/Context";
import CreateDebtToPayForm from './CreateDebtToPayForm'
import { fetchProviders } from '../../helpers/api/provider'
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination'
import { PreloadState } from '../UI/preloading/PreloadState';
import SupportLink from '../root/support/components/SupportLink'
import useModuleBase from '../../helpers/hooks/useModuleBase'

const CreateDebtToPay = ({ setRedirectUrl, setRedirect }) => {

    const { id } = useParams();
    const { currency: curr } = useContext(CurrencyContext);
    const activeExchangeRate = Number(curr?.value ?? 0);
    // Vuelve al listado del módulo desde el que se entró (finanzas,
    // contabilidad o fondos), no siempre a Finanzas.
    const moduleBase = useModuleBase();

    const [params] = useState({
        condominiumId: id
    })

    const {
        data,
        isLoading,
        meta,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(fetchProviders, params);

    const create = async values => {

        const { provider, amount, voucher, details, name } = values;

        try {
            const formData = new FormData();
            formData.append('provider', provider);
            formData.append('details', details);
            formData.append('amount', amount);
            formData.append('name', name);
            if (activeExchangeRate) formData.append("rate", activeExchangeRate);
            if (voucher) {
                formData.append('voucher', voucher);
            }
            const { code } = await createDebtToPay(formData);

            if (code === SUCCESS_RESPONSE.SUCCESFUL) {
                setRedirectUrl(`/dashboard/${moduleBase}/${id}/topay`);
                setRedirect(true);
                Toast.fire({
                    type: 'success',
                    title: `Cuenta por pagar registrada exitosamente.`,
                });
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }


    return <>
                <PageHeader
                    title="Registrar cuenta por pagar"
                    titleTag="h2"
                    description="Registra una cuenta por pagar y controla la economía del condominio."
                    className="mb-3"
                    col={{ lg: 9 }}
                >
                <SupportLink />
                </PageHeader>
                <PreloadState loading={isLoading}>
                    <CreateDebtToPayForm handleSubmitData={create} handler={{ nextPage, previousPage, perPage, goToPage, meta }} providers={data} />
                </PreloadState>
            </>
}

export default withRedirect(CreateDebtToPay)
